// extracted by mini-css-extract-plugin
module.exports = {"DbDashboardCol":"DbDashboardCol_h9XdK"};